module.exports = __webpack_public_path__ + "img/TECHNOLOGY-FRONX-BOOSTERGREEN-2.3f4ebb48.jpg";